export default "__VITE_ASSET__B7Z46Un1__"